import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './loginForm';
import HomePage from './home';
import StudentTickets from './pages/studentTickets';
import Attendance from './pages/attendance';


const StudentApp = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/student/tickets" element={<StudentTickets />} />
        <Route path="/student/attendance" element={<Attendance />} />
      </Routes>
    </div>
  );
};

export default StudentApp;